// removed by extract-text-webpack-plugin
module.exports = {"workaround":"_1KUcoBXf","button":"_17vfvk8W","legacyBrowserPopup":"_1nQhcGMa","links":"_2QJVMDYs"};


//////////////////
// WEBPACK FOOTER
// ./app/account/containers/login/login.component.scss
// module id = 375
// module chunks = 0